import { useCallback, useEffect, useState } from "react";
import { Paperclip, MessageSquare, ClipboardList, Reply, CheckCheck, Send, AlertTriangle } from "lucide-react";
import { api } from "../../lib/api";
import { dateTimeBR } from "../../lib/format";
import { Card, CardHead } from "../common";
import { RequestDetailSheet } from "../RequestDetailSheet";
import { ProcessSheet } from "../FileCenter";

const KIND = { CLIENT_FILE_UPLOADED: [Paperclip, "Arquivo recebido"], CLIENT_FILE_VERSION: [Paperclip, "Nova versão de arquivo"], CLIENT_MESSAGE_CREATED: [MessageSquare, "Nova mensagem"],
  CLIENT_REPLIED: [Reply, "Cliente respondeu"], CLIENT_DEMAND_CREATED: [ClipboardList, "Nova solicitação"], CLIENT_CLOSING_SENT: [Send, "Fechamento recebido"],
  CLIENT_POST_CLOSING: [AlertTriangle, "Alteração após fechamento"] };

export function ClientNews({ cid, onChanged }) {
  const [rows, setRows] = useState(null);
  const [req, setReq] = useState(null);
  const [proc, setProc] = useState(null);
  const load = useCallback(() => api.get(`/admin/clients/${cid}/interactions`).then((r) => setRows(r.data)), [cid]);
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, [load]);
  const open = async (i) => {
    await api.post(`/admin/interactions/${i.id}/read`);
    if (i.demand_id) setReq(i.demand_id); else if (i.process_id) setProc(i.process_id);
    load(); onChanged && onChanged();
  };
  const done = () => { load(); onChanged && onChanged(); };
  if (!rows) return null;
  return (
    <Card testid="client-news" className={rows.length ? "border-rose-200" : ""}>
      <CardHead title={rows.length ? `Novas interações (${rows.length})` : "Novas interações"} hint="Tudo o que o cliente mandou e ainda não foi visto pela equipe. Abrir marca como lida, mas a demanda continua aberta até ser resolvida." />
      <div className="divide-y border-t">
        {rows.map((i) => { const [I, label] = KIND[i.kind] || [ClipboardList, "Nova interação"]; return (
          <button key={i.id} onClick={() => open(i)} data-testid={`client-news-item-${i.id}`} className="w-full flex items-start gap-3 px-5 py-3 text-left hover:bg-rose-50/40">
            <span className="mt-0.5 h-7 w-7 rounded-full bg-rose-100 text-rose-700 flex items-center justify-center shrink-0"><I className="h-3.5 w-3.5" /></span>
            <span className="flex-1 min-w-0"><span className="text-sm font-semibold">{label}</span> <span className="text-sm">· {i.title}</span>
              {i.text && <span className="block text-xs text-slate-600 truncate">"{i.text}"</span>}
              {i.files?.length > 0 && <span className="block text-xs text-indigo-700">{i.files.join(", ")}</span>}
              <span className="block text-[11px] text-slate-400">{dateTimeBR(i.created_at)} · {i.created_by}{i.protocol ? ` · #${i.protocol}` : ""}</span></span>
            <span className="text-xs font-semibold text-indigo-700 shrink-0">Abrir</span>
          </button>); })}
        {!rows.length && <div className="px-5 py-4 text-sm text-emerald-700 flex items-center gap-1.5" data-testid="client-news-empty"><CheckCheck className="h-4 w-4" />Nenhuma interação nova. Tudo visto.</div>}
      </div>
      <RequestDetailSheet id={req} open={!!req} onOpenChange={(o) => !o && setReq(null)} onChanged={done} />
      <ProcessSheet id={proc} open={!!proc} internal onOpenChange={(o) => !o && setProc(null)} onChanged={done} />
    </Card>
  );
}
